<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    翠竹站<br>
站点介绍<br>
翠竹站位于罗湖区东门北路与翠竹路、华丽路相交汇处地下，呈一字形沿东门北路呈东北、西南走向。翠竹站四个出入口分别是：B1出入口海洋大厦、桂园中学；B2出入口木头龙；C出入口华润万家及康宁医院；D出入口深圳市人民医院、深圳市孙逸仙心血管病医院。翠竹站以白色为主色调，柱体采用白色搪瓷钢板，在标准化、简约化的装修中赋予了车站浓厚的文化气息。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:13	23:47	3号线	2分15-20秒	4分30秒<br>
双龙	06:03	23:26	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:22	23:46	3号线	3分15秒	5分钟<br>
双龙	06:11	23:26	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:22	00:46	3号线	3分15秒	5分钟<br>
双龙	06:11	00:26	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
B1出入口:<br>
东门北路南侧（西）、华丽路西侧、翠园中学高中部、深圳市翠竹外国语实验学校、华达小区、木头龙住宅小区<br><br>
B2出入口:<br>
华丽路东侧、深圳明珠学校、鸿业苑、翠华花园<br><br>
C出入口:<br>
东门北路北侧（东）、翠竹路、翠竹苑、华丽园住宅小区、金福大厦、翠都花园<br><br>
D出入口:<br>
东门北路北侧（西）、旺业豪苑、文锦广场、深圳市人民医院<br><br>
公交换乘信息<br><br>
B2出入口:<br>
公交站名： 木头龙<br>
N2路,M348路,13路,57路,65路,83路,218路,242路,211路,306路,M399路,深圳北-东部华侨城旅游专线,3路,64路,103路,103B路,113路,202路,333路,351路,E11路,E11区间线,E12路,M407路,M481路,N3路,高峰专线97路,机场6线<br><br>
B2出入口:<br>
公交站名： 留医部①<br>
N2路,M348路,13路,57路,65路,83路,218路,242路,211路,306路,M399路,深圳北-东部华侨城旅游专线,3路,64路,103路,103B路,113路,202路,333路,351路,E11路,E11区间线,E12路,M407路,M481路,N3路,高峰专线97路,机场6线<br><br>
B2出入口:<br>
公交站名： 留医部②<br>
N2路,M348路,13路,57路,65路,83路,218路,242路,211路,306路,M399路,深圳北-东部华侨城旅游专线,3路,64路,103路,103B路,113路,202路,333路,351路,E11路,E11区间线,E12路,M407路,M481路,N3路,高峰专线97路,机场6线<br><br>
C出入口:<br>
公交站名： 翠竹苑<br>
2路,40路,57路,59路,62路,107路,225路,242路,M348路,M482路,N6路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>